import {
  AccountNormalBalance,
  AccountRecord,
  AccountType,
} from '../../../../types/accounting';

export const ACCOUNT_TYPE_OPTIONS: { value: AccountType; label: string }[] = [
  { value: 'asset', label: 'Asset' },
  { value: 'liability', label: 'Liability' },
  { value: 'equity', label: 'Equity' },
  { value: 'revenue', label: 'Revenue' },
  { value: 'cogs', label: 'COGS' },
  { value: 'expense', label: 'Expense' },
  { value: 'other_income', label: 'Other Income' },
  { value: 'other_expense', label: 'Other Expense' },
];

export const NORMAL_BALANCE_OPTIONS: {
  value: AccountNormalBalance;
  label: string;
}[] = [
  { value: 'debit', label: 'Debit' },
  { value: 'credit', label: 'Credit' },
];

export interface AccountFormState {
  code: string;
  name: string;
  type: AccountType;
  subtype: string;
  parentAccountId: string;
  normalBalance: AccountNormalBalance;
  isActive: boolean;
  allowsManualEntries: boolean;
}

export const createEmptyAccountForm = (): AccountFormState => ({
  code: '',
  name: '',
  type: 'asset',
  subtype: '',
  parentAccountId: '',
  normalBalance: 'debit',
  isActive: true,
  allowsManualEntries: true,
});

export const createAccountFormFromRecord = (
  account: AccountRecord,
): AccountFormState => ({
  code: account.code,
  name: account.name,
  type: account.type,
  subtype: account.subtype ?? '',
  parentAccountId: account.parent_account_id ?? '',
  normalBalance: account.normal_balance,
  isActive: account.is_active,
  allowsManualEntries: account.allows_manual_entries,
});

export const formatAccountTypeLabel = (value: AccountType) =>
  ACCOUNT_TYPE_OPTIONS.find((option) => option.value === value)?.label || value;
